module.exports = __webpack_public_path__ + "img/twitter-icon.7571ea13.png";